module.exports = __webpack_public_path__ + "static/media/dont2.0707a796.png";